import { Observable } from 'rxjs';
import { ConfiguracionProducto } from 'src/app/global/interfaces/configuracion-producto';
import { ObtenerUrlPagoResponse } from 'src/app/global/interfaces/obtener-url-pago-response';
import { SeleccionProductoRequest } from 'src/app/global/interfaces/seleccion-producto.request';
import { Product } from '../components/shopping-cart/product';

export abstract class vmProductosService {

  abstract productos: Product[];

  abstract registraSeleccionProducto(productos: SeleccionProductoRequest[]): Observable<any>;

  abstract validaPagoProducto(): Promise<any>;

  abstract obtenerUrlPago(): Promise<ObtenerUrlPagoResponse>;

  abstract registraSeleccionProductoActual(): Observable<unknown>;

  abstract cargaSeleccionActualEnCarro(): Observable<Product[]>;

  abstract validarSolicitudVacia(products: Product[]): void;

  abstract existenProductosEnCarro(): number;

  abstract postConfiguracionProducto(data: any): Observable<any>;

  abstract obtenerConfiguracionProducto(): Observable<ConfiguracionProducto>;

  abstract obtieneSeleccionProducto(): Observable<Product[]>;

  abstract cargarEnCarro(products: Product[]);

  abstract resumenPago(): Observable<any>;

  abstract validaPagoProductoProactivo(run: number): Observable<any>;

  abstract obtenerValorUF(): Observable<any>;

  abstract obtenerValoresMCC(): Observable<any>;

  abstract validarDescuento(descuento : String) : Observable<any>;
}
